<template>
  <form @submit.prevent="submit" class="form-horizontal">
    <div class="panel panel-default">
      <div class="panel-body">
        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            :error="(errors.name || [])[0]"
        />

        <TextFormGroup
            v-model="data.url"
            name="url"
            label="URL"
            :error="(errors.url || [])[0]"
        />

        <GalleryFormGroup
            v-model="data.image_id"
            name="image_id"
            label="Image"
            :error="(errors.image_id || [])[0]"
        />

        <hr>

        <SubmitFormGroup button-class="btn-black"/>
      </div>
    </div>
  </form>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
import HelpText from '@/components/HelpText'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    GalleryFormGroup,
    SubmitFormGroup,
    TextFormGroup
  },

  mixins: [Errors],

  props: {
    portalCompany: {
      required: true
    }
  },

  data() {
    return {
      data: {},
    }
  },

  methods: {
    submit() {
      http.post('/api/v2/brands', {...this.data, portal_company_id: this.portalCompany.id})
          .then(() => {
            notify.success('The brand was saved')

            this.$router.push('.')
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
